import {MignonFilet, SalmonFilet, CaesarSalad, Carbonara, Cook2, Cook1, Cook3, Cook4} from "../components/Assets";
import {AboutItemStatic, CookInfoItemStatic} from "../../types";

export const AboutData: AboutItemStatic[] = [
    {
        id: 1,
        title: 'Стейк Филе-миньон',
        imgSrc: MignonFilet,
    },
    {
        id: 2,
        title: 'Стейк Лосося',
        imgSrc: SalmonFilet,
    },
    {
        id: 3,
        title: 'Салат Цезарь',
        imgSrc: CaesarSalad,
    },
    {
        id: 4,
        title: 'Паста Карбонара',
        imgSrc: Carbonara,
    },
];

export const CooksInfoData: CookInfoItemStatic[] = [
    {
        id: 1,
        title: 'Анатолий Бордиян',
        text: "Анатолий Бордиян по прозвищу Борщ – фанат кулинарии, шеф-повар, которому по плечу как традиционная," +
            " так и молекулярная кухня. Поварское мастерство Анатолий оттачивал в Штатах, а вернувшись в Россию," +
            " успешно продемонстрировал его в популярных ресторанах Санкт-Петербурга и Москвы." +
            " Анатолий Бордиян работал в таких заведениях, как «Dr.Живаго», «Гастроном», «Юзу» и др." +
            " Готовил для первых лиц государства. Борщ отличается креативным подходом: именно он приготовил стейк на утюге," +
            " курицу в стиральной машине и шашлык на воздушном шаре. Фишкой Анатолия является то," +
            " что во время готовки он нередко говорит слово «бабаски» – для многих слово загадочное," +
            " однако на самом деле обозначает научный термин: при разделке кролика и при изъятии печёнки может найти" +
            " еще одну пару миниатюрных печёнок, которые и называются бабаски.",
        imgSrc: Cook1,
    },
    {
        id: 2,
        title: 'Александр Кравченко',
        text: "Знаменитый столичный шеф-повар известного во всем мире ресторанного холдинга Ginza Project," +
            " с богатым международным опытом. Элитную авторскую кухню, деликатесы французской и итальянской кухни," +
            " оригинальную подачу и всю изюминку шеф -повара \"с именем\" Вы откроете и оцените для себя не только в" +
            " основном меню рестобара «Моn Tresor», но и в дневном меню, специально разработанного для деловых персон." +
            " Деловое меню удивит и демократичными ценами на комплексный обед, который Вы можете составить самостоятельно!",
        imgSrc: Cook2,
    },
    {
        id: 3,
        title: 'Александр Чернышов',
        text: "Шеф-повар Александр Чернышов имеет большой опыт работы в ресторанах Москвы, многочисленные стажировки в Италии." +
            " Постоянное повышение квалификации позволили Александру руководить направлением R&D и разработкой концепций" +
            " в крупнейших сетевых компаниях (Cofix и Dodo Pizza), запускать успешные гастрономические проекты в Москве" +
            " и других регионах России, а также в Китае и Бразилии." +
            " За плечами Александра работа бренд-шефом в крупнейших международных компаниях," +
            " таких как Unilever (бренды Hellmanns, Knorr, Tabasco, Carte D’or) и Electrolux Professional Russia," +
            " участие в важнейших отраслевых выставках: PIR EXPO, METRO EXPO и др.",
        imgSrc: Cook3,
    },
    {
        id: 4,
        title: 'Ильгиз Галиев',
        text: "Ильгиз Галиев — вице-президент Гильдии поваров Татарстана, шеф-повар года РТ по версии WHERETOEAT." +
            " Его любимые гастрономические направления — классическая и модерновая татарская кухня, итальянская и паназиатская." +
            " Плюс давнее стремление к экспериментам в каждом из них (авторские wok и пиццетти — предметы особой гордости шефа)." +
            " Свою профессиональную карьеру Ильгиз начал в 2002 году, в ресторане «Шираз». Дальше были казанские «Канпай», «Круиз»" +
            " (здесь состоялся дебют в качестве шеф-повара), «Эскобар», «Европа»…Сегодня Ильгиз Галиев, помимо всего прочего," +
            " является преподавателем столичной Novikov School и Казанского кооперативного института (где ведет предмет «Технологии ресторанной продукции»)," +
            " а также тренером сборной России WorldSkills по сервису.Ильгиз рассказывает, что в своих блюдах проявляет «погоду своей души»." +
            " При этом часть новинок — это, буквально, воплощенные сны, увиденные накануне.",
        imgSrc: Cook4,
    }
];
